<template>
  <Modal :id="id" :modalTitle="modalTitle" :class="classes">
    <label class="generalLabel" for="documentNumber">DNI</label>
    <input type="text" class="form-control generalInput" id="documentNumber"
      v-model.trim.lazy="v$.documentNumber.$model">
    <div v-if="v$.documentNumber.$dirty">
      <small class="form-text text-danger" v-if="v$.documentNumber.$invalid">El
        formato no es correcto</small>
    </div>
    <button class="btn btn-primary generalPrimaryButton float-right mt-5" data-dismiss="modal" aria-label="Close" :disabled="v$.$invalid" @click="modifiedData()">Confirmar</button>
  </Modal>
</template>

<script>

import Modal from '../../Shared/Modal.vue';
import useVuelidate from '@vuelidate/core';
import axios from 'axios';

const dniNumber = (value) => {
  var numero, le, letra;
  var expresion_regular_dni = /^[XYZ]?\d{5,8}[A-Z]$/;

  value = value.toUpperCase();

  if (expresion_regular_dni.test(value) === true) {
    numero = value.substr(0, value.length - 1);
    numero = numero.replace('X', 0);
    numero = numero.replace('Y', 1);
    numero = numero.replace('Z', 2);
    le = value.substr(value.length - 1, 1);
    numero = numero % 23;
    letra = 'TRWAGMYFPDXBNJZSQVHLCKET';
    letra = letra.substring(numero, numero + 1);
    if (letra != le) {
      return false;
    } else {
      return true;
    }
  } else {
    return false;
  }
}

export default {
  name: 'EditLegalIdentifier',
  setup() {
    return { v$: useVuelidate() }
  },
  props: [
    'id',
    'modalTitle',
    'class',
    'list'
  ],
  data() {
    return {
      classes: this.class,
      documentNumber: '',
    }
  },
  validations() {
    return {
      documentNumber: {
        dniNumber
      },
    }
  },
  components: {
    Modal,
  },
  methods: {
    modifiedData() {
      let bodyToSend = {
        legalIdentifier: this.documentNumber,
        mobile: this.list.mobile,
        email: this.list.email,
        street: this.list.street,
        number: this.list.number,
        postalCode: this.list.postalCode,
        city: this.list.city,
        province: this.list.province,
        surname: this.surname
      }
      axios.patch(`/customer/blacklist-update-legal-identifier/${this.list.legalIdentifier}`, bodyToSend)
        .then(() => {
          axios.get(`/customer/blacklist-legal-identifier/${bodyToSend.legalIdentifier}`)
          .then((response) => {
            this.$emit("refreshRegisterList", response.data);
          });
        });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">

</style>
